module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-sm-12 hidden-xs align-right footer-bottom"
  }, [_c('a', {
    attrs: {
      "href": "mailto:stonavsky@kovosport.cz"
    }
  }, [_vm._v("stonavsky@kovosport.cz")]), _vm._v(" +420 603 573 882\n")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f8a567e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/FooterContact.vue
// module id = 1206
// module chunks = 1